export function cartDialogSort(a, b) {
  // sort cart items by Part Number
  if (a.PN < b.PN) return -1;
  if (a.PN > b.PN) return 1;
  return 0;
}
